import { useTenantDetailsContext } from '@/modules/tenant/TenantDetailsContext/TenantDetailsContext';

/**
 * @returns true if the current user can interact with Snowflake.
 * Snowflake data sharing is tenant-wide today (no per-user auth),
 * so this is equivalent to useCanUserConnectToSnowflake for now.
 */
export function useIsUserLoggedIntoSnowflake() {
  return useCanUserConnectToSnowflake();
}

/**
 * @returns true if Snowflake data sharing is enabled on the tenant.
 */
export function useCanUserConnectToSnowflake() {
  const { integrationConfiguration } = useTenantDetailsContext();

  return Boolean(integrationConfiguration?.snowflakeDataSharingEnabled);
}
